export const track = <T extends { unsubscribe: () => void }>(arr: T[], sub: T): T => {
  arr.push(sub);
  return sub;
};
